/* eslint-disable spire/export-styles */
import { themeFonts, themeFontWeights } from "@DSG/MobiusOverrides/styles/variables";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cartActionsStyles } from "@insite/content-library/Widgets/Cart/CartActions";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
    cart: getCurrentCartState(state).value,
});

export interface PageTitleStyles {
    pageTitle: TypographyPresentationProps;
}

export const pageTitleStyles: PageTitleStyles = {
    pageTitle: {
        variant: "h2",
        weight: themeFontWeights.semiBold,
        fontFamily: themeFonts.fontFamilyPoppins,
        css: css`
            margin-bottom: 16px;
            ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin-bottom: 24px;
                    `,
                ],
                "min",
            )}
        `
    }
}


type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields,cart }: Props) => {
    const styles = pageTitleStyles;
    let isCheckoutPage  = false;
    if(pageTitle === "Payment And Review")
    {
        isCheckoutPage = true;
    }

    return (
        <>
        {!isCheckoutPage && (
        <Typography variant="h1"  data-test-selector="PageTitle">
             {!isCheckoutPage && (fields.overrideTitle != "Cart" && pageTitle != "Cart") &&(
                <>
                      {fields.overrideTitle || pageTitle}
                </>
            )}
            {!isCheckoutPage && (fields.overrideTitle === "Cart" || pageTitle === "Cart") &&(
                <>
                      {fields.overrideTitle || pageTitle} 
                      {cart && cart.cartLines && cart.cartLines.length > 1 && (
                        <Typography>: {cart?.cartLines?.length.toLocaleString()} {translate("items")} </Typography>
                      )}
                      {cart && cart.cartLines && cart.cartLines.length == 1 && (
                        <Typography>: {cart?.cartLines?.length} {translate("item")} </Typography>
                      )}
                     
                </>
            )}
          
    </Typography>
    )}
    {isCheckoutPage && (
        <Typography {...styles.pageTitle} data-test-selector="PageTitle" variant="h2" as="h1">{translate("Payment & Review")}</Typography>
    )}
    </>
    );

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
